import {number_format} from '../../../utils/formatter';
import {checkEarlierThanCreationDate} from './CommonHelper'

/**
 * 그래프 말풍선 [ 그래프 라이브러리에서는 반드시 String으로 리턴해야된다. ]
 * @param item
 * @returns {string}
 */
export const balloon = (item, countField, tailText, minDate) => {
  const {index, graph, dataContext} = item;
  const dataList = graph.data;
  const {activeDateType, timestamp} = dataContext;
  const pv = dataContext[countField];
  const prev = dataList[index - 1];
  const dateType = {day: "일간", week: "주간", month: "월간"};
  const dateTypeName = dateType[activeDateType];

  // 생성일자를 체크한후 그날짜봅다 작으면 - 으로 치환한다.
  const isEarlierThanCreationDate = checkEarlierThanCreationDate(activeDateType, timestamp, minDate);
  const pvWithCreationDate = (isEarlierThanCreationDate) ? "-" : number_format(pv);

  // 말풍선 변화 상태를 나타내는 HTML
  let statusHtml = "";
  if (index >= 0 && prev && prev.hasOwnProperty('dataContext') && !isEarlierThanCreationDate) {

    let changedPv = pv - prev.dataContext[countField];

    if (changedPv > 0) {
      statusHtml = `<span class="ico_blog ico_up"></span><span class="num_g num_up">${number_format(changedPv) }</span>`
    }
    else if (changedPv < 0) {
      statusHtml = `<span class="ico_blog ico_down"></span><span class="num_g num_down">${number_format(Math.abs(changedPv))}</span>`
    }
  }

  // 최종 Render
  return `<div class="layer_popup">
                 <div class="inner_popup inner_popup_type1">
                    <strong class="tit_popup"><em>${dateTypeName}</em> <span class="inner_g">${tailText}</span></strong>
                    <div class="current_num"><span class="num_graph">${pvWithCreationDate}</span>${statusHtml}</div></div>
                </div>
            </div>`;
};
